export const EXTRA_TEASER_FIELD_OPTIONS = [
    {},
];
